// Pure formatting helpers for the Annotation tool page.
// Extracted from frontend/src/AnnotationPage.js to keep that page focused on
// state/handler logic and the high-level layout.

export const formatTimestamp = (value) => {
  if (!value) return '—';
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleString();
  } catch (_) {
    return String(value);
  }
};

export const formatMoney = (value) => {
  if (value === null || value === undefined) return '-';
  const n = Number(value);
  if (!Number.isFinite(n)) return '-';
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
